import React from 'react';
import ReactDOM from 'react-dom/client';
import Routers from './routers';
import reportWebVitals from './reportWebVitals';
import './style/main.scss';
import 'aos/dist/aos.css';
import AOS from 'aos';
import store from './store';
import { Provider } from 'react-redux';
import ToastComponent from './components/Toast';
// Android (Capacitor)
import { App } from '@capacitor/app';
import { backButtonListener } from './utils';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
AOS.init({
	easing: 'ease-in-out',
	duration: 500,
	once: false,
	mirror: true,
});
App.addListener('backButton', async function (e) {
	backButtonListener(App);
});
root.render(
	<Provider store={store}>
		<ToastComponent />

		{/* <RouterProvider router={routers} /> */}
		<Routers />
	</Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
